import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from '@auth0/angular-jwt';

import { Globals } from '../_globals';

import { CryptoService } from './crypto.service';



@Injectable()
export class AuthService {

    helper = new JwtHelperService();
    _cryptoService: CryptoService = new CryptoService();

    constructor(
        private http: HttpClient,
        private router: Router,
        public globals: Globals,
        private cookieService: CookieService
    ) { }

    public login(creds) {


        const headers = new HttpHeaders().set(environment.InterceptorSkipHeader, '');

        return this.http.post(environment.apiUrl + 'api/authenticate', creds, { headers })
            .pipe((res: any) => {
                res.subscribe(data => {

                    // tslint:disable-next-line:max-line-length
                    const expirationDate = this.helper.getTokenExpirationDate(data.id_token);
                    // console.log('token expires', expirationDate);

                    const cookieExp = new Date(expirationDate);
                    cookieExp.setDate(expirationDate.getDate() + 30);
                    // console.log('cookie expires', cookieExp);

                    this.cookieService.set(environment.keys.accessToken, this._cryptoService.encryptText(data.id_token), cookieExp, '/');
                    this.cookieService.set(environment.keys.username, this._cryptoService.encryptText(creds.username), cookieExp, '/');
                    this.cookieService.set(environment.keys.password, this._cryptoService.encryptText(creds.password), cookieExp, '/');


                });
                return res;
            })
            .pipe(catchError(this.handleError));
    }


    public storeGlobalUserAndOrg(user) {

        return new Observable(observer => {

            this.globals.user = {
                id: user.id,
                authorities: user.authorities,
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                langKey: user.langKey,
                login: user.login,
                organisation: user.organisation
            };

            if (user.authorities.find(auth => auth.name === 'ROLE_ADMIN')) {

                this.globals.user.role = 4;
                this.globals.user.routeRole = 'super';

            } else if (user.authorities.find(auth => auth.name === 'ROLE_GROUP')) {

                this.globals.user.role = 3;
                this.globals.user.routeRole = 'group';

            } else if (user.authorities.find(auth => auth.name === 'ROLE_STORE_OWNER')) {

                this.globals.user.role = 2;
                this.globals.user.routeRole = 'owner';

            } else if (user.authorities.find(auth => auth.name === 'ROLE_CONSOLE')) {

                this.globals.user.role = 1;
                this.globals.user.routeRole = 'console';

            } else {
                this.globals.user.role = 0;
            }

            return observer.next(this.globals);


        });


    };

    public logout() {

        console.log('lets logout');
        this.cookieService.deleteAll('/');
        this.router.navigate(['/signin']);
    }


    public refreshToken(creds) {
        // console.log('refreshing token...');
        const headers = new HttpHeaders().set(environment.InterceptorSkipHeader, '');
        return this.http.post(environment.apiUrl + 'api/authenticate', creds, { headers });
    }


    public isLoggedIn() {

        const loggedin = this.cookieService.check(environment.keys.accessToken);
        return loggedin;
    }



    public getUser() {

        return this.http.get(environment.apiUrl + 'api/ext-bludot-user/current')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }





    // HANDLE DATA & ERRORS FUNCTIONS


    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/auth.service.ts